import { EQM2070DetailTabType } from "../Store_EQM2070_R01";

export const EQM2070_R01_EQUIPMENT_CD = {
	NICKEL_CHROME: "PLATING",
	ZINC: "PLATING2",
} as const;

export const EQM2070_R01_DETAIL_TABS = [
	{
		id: EQM2070_R01_EQUIPMENT_CD.NICKEL_CHROME as EQM2070DetailTabType,
		label: "니켈크롬라인",
	},
	{
		id: EQM2070_R01_EQUIPMENT_CD.ZINC as EQM2070DetailTabType,
		label: "아연라인",
	},
] as const;
